// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1772817871286
      var cssReload = require("C:/DiscoE/3x1010/Projects-CATI/dev.catispa.com/app/public/wp-content/themes/cati/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"./","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  